import { assoc, curry, keys, reduce } from 'rambdax';

// Shallow object clean
const cleanObjectValues = (obj) => {
  const newObj = {};

  Object.keys(obj).forEach((key) => {
    if (obj[key] != null) {
      newObj[key] = obj[key];
    }
  });

  return newObj;
};

/**
 * Borrowed from * https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object
 *
 * Creates a new object with the own properties of the provided object, but the
 * keys renamed according to the keysMap object as `{oldKey: newKey}`.
 * When some key is not found in the keysMap, then it's passed as-is.
 *
 * Keep in mind that in the case of keys conflict is behaviour undefined and
 * the result may vary between various JS engines!
 *
 * @param keysMap {object} An object with {oldKey: newKey}
 * @param obj {object}
 */
const renameKeys = curry((keysMap, obj) => {
  return reduce((memo, key) => {
    return assoc(keysMap[key] || key, obj[key], memo);
  }, {})(keys(obj));
});

const isObjectLiteral = (obj) =>
  !!obj && (Object.getPrototypeOf(obj) === null || obj.constructor === Object);

export { cleanObjectValues, isObjectLiteral, renameKeys };
